// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"a40dd14c","703":"9b420aaa"}[chunkId] + ".chunk.js";
};